module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 header"
  }, [_c('router-link', {
    staticClass: "back-link material-icons",
    attrs: {
      "to": "/lists"
    }
  }, [_vm._v("chevron_left")]), _vm._v(" "), (!_vm.editMode) ? _c('i', {
    staticClass: "material-icons add-link",
    on: {
      "click": function($event) {
        _vm.changeEditMode()
      }
    }
  }, [_vm._v("edit_mode")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('i', {
    staticClass: "material-icons add-link",
    on: {
      "click": function($event) {
        _vm.changeEditMode()
      }
    }
  }, [_vm._v("done")]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.list.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 list"
  }, [(_vm.sortedListItems) ? _c('ul', {}, _vm._l((_vm.sortedListItems), function(listItem, index) {
    return _c('app-list-item', {
      staticClass: "list-item",
      attrs: {
        "listItem": listItem,
        "index": index,
        "editMode": _vm.editMode
      }
    })
  })) : _c('p', [_vm._v("No Items yet! Add some.")]), _vm._v(" "), (_vm.editMode || !_vm.list.listItems) ? _c('router-link', {
    staticClass: "mdl-button mdl-button--raised",
    attrs: {
      "tag": "button",
      "to": '/lists/' + _vm.$route.params.id + '/edit'
    }
  }, [_vm._v("Add Items")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7381d785"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 138
// module chunks = 0